export default {
	common: {
		noMore: "これ以上データはありません",
		noData: "データがありません！",
		loading: "読み込み中...",
		gotIt: "了解しました",
		confirm: "確認",
		cancel: "キャンセル"
	},
	activity: {
		title: "キャンペーン",
		rule: "キャンペーン規約",
		stockNotEnough: "在庫不足",
		soldOut: "売り切れ",
		addCartSuccess: "カートに追加しました",
		maxPurchaseLimit: "最大{num}個まで購入可能",
	},
	inivteFriends: {
		title: "友だち招待",
		earn: "獲得",
		for: "ごとに",
		eachFriendInvited: "友だち1人を招待",
		myRewards: "マイリワード",
		received: "受け取り済み",
		invited: "招待済み",
		shareNow: "今すぐ共有",
		welcomeGift: "ウェルカムギフト",
		invitedFriends: "招待した友だち",
		noSuccessfulInvites: "成功した招待はありません",
		howItWorks: "使い方",
	},
	document: {
		title: "ドキュメント",
	},
}
